import { format } from 'date-fns';
import React from 'react';
import useUserDetails from '../../hooks/useUserDetails';
import type { TripCard } from '../../redux/trip/trip.types';
import { getVisibleDisplayName } from '../../utils/accountConstants';
import './UserAddedSpan.scss';

type UserAddedProps = {
  card: TripCard;
  isMobile?: boolean;
};

function UserAddedSpan({ card, isMobile = false }: UserAddedProps) {
  const { userData, loading } = useUserDetails(card.creator);
  const dateAdded = card.dateAdded ? new Date(card.dateAdded) : null;

  // Don't render anything while loading initial data
  if (loading && !userData) {
    return null;
  }

  // Only render if we have user data
  if (!userData) {
    return null;
  }

  return (
    <div className='user-added-container'>
      <span className='user-added-text'>
        Added by{' '}
        {getVisibleDisplayName({
          displayName: userData.displayName || userData.email || '',
          status: userData.status === 'deactivated' ? 'deactivated' : 'active',
        })}
        {dateAdded && <span> • {format(dateAdded, 'MMM d, yyyy')}</span>}
      </span>
    </div>
  );
}

UserAddedSpan.displayName = 'UserAddedSpan';
export default UserAddedSpan;
